import React, { useState, useEffect } from 'react';

/**
 * A loading fallback component that delays visibility to prevent flash
 * on quick page loads. Shows a smooth loading spinner after a brief delay.
 */
function PageLoadingFallback({ delayMs = 200 }) {
    const [showLoading, setShowLoading] = useState(false);

    useEffect(() => {
        // Only show loading indicator after a delay to prevent flash
        const timer = setTimeout(() => {
            setShowLoading(true);
        }, delayMs);

        return () => clearTimeout(timer);
    }, [delayMs]);

    // Don't render anything during the delay period
    if (!showLoading) {
        return null;
    }

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-50">
            <div className="flex flex-col items-center gap-4 animate-fade-in">
                <div className="spinner-lg"></div>
                <p className="text-gray-500 text-sm font-medium">Loading...</p>
            </div>
        </div>
    );
}

export default PageLoadingFallback;
